/** Tiny localStorage helpers shared by toolkit tools (favourites, recents, decks). */
export function readJson<T>(key: string, fallback: T): T {
  if (typeof window === "undefined") return fallback;
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

export function writeJson(key: string, value: unknown) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* quota or private mode — non-fatal */
  }
}

export type RecentTool = { id: string; name: string; category: string; at: number };

const RECENT_KEY = "jt_recent_tools";
export const FAVORITES_KEY = "jt_favorite_formulae";

export function pushRecentTool(entry: Omit<RecentTool, "at">) {
  const list = readJson<RecentTool[]>(RECENT_KEY, []);
  const next = [{ ...entry, at: Date.now() }, ...list.filter((r) => r.id !== entry.id)].slice(0, 24);
  writeJson(RECENT_KEY, next);
}

export function readRecentTools(): RecentTool[] {
  return readJson<RecentTool[]>(RECENT_KEY, []);
}

export type FavoriteFormula = { id: string; title: string; body: string; source: string; at: number };

export function readFavorites(): FavoriteFormula[] {
  return readJson<FavoriteFormula[]>(FAVORITES_KEY, []);
}

export function toggleFavorite(item: Omit<FavoriteFormula, "at">): FavoriteFormula[] {
  const list = readFavorites();
  const exists = list.some((f) => f.id === item.id);
  const next = exists
    ? list.filter((f) => f.id !== item.id)
    : [{ ...item, at: Date.now() }, ...list];
  writeJson(FAVORITES_KEY, next);
  return next;
}
